import {isNil} from 'ramda';

import {TitleExtensionLanguage} from '@dms/api/sales';

import {TitleExtensionEquipmentFormValues} from '../schemas/titleExtensionEquipmentDraftSchema';

const PREVIEW_ITEM_LIMIT = 6;

export function getPreviewShortNames(
  items: TitleExtensionEquipmentFormValues['items'],
  activeLanguage?: TitleExtensionLanguage
) {
  if (isNil(activeLanguage)) {
    return [];
  }

  const uniqueNames = new Set<string>();
  items.forEach((item) => {
    const shortName = (
      item.shortNames.find((candidate) => candidate.language === activeLanguage)?.shortName ?? ''
    ).trim();
    if (shortName) {
      uniqueNames.add(shortName);
    }
  });

  return [...uniqueNames].slice(0, PREVIEW_ITEM_LIMIT);
}
